import React, { useState, useEffect, memo } from 'react';
import {
  useNavigate,
  useLocation,
  useSearchParams,
} from 'react-router-dom';
import { Loader } from '@cashfree-intl/coherent';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _last from 'lodash/last';
import _compact from 'lodash/compact';

import { StyledPage } from './styled';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import makeSelectLandingPage from 'containers/LandingPage/selectors';
import ErrorBoundary from 'containers/ErrorBoundary';
// import DynamicForm from 'PaymentForms/DynamicForm';

const DynamicForm = React.lazy(() => import('PaymentForms/DynamicForm'));

const Forms = ({ handleSubmit, landingData: { helpCenter: { serverData } } }) => {

  return (
    <ErrorBoundary fallback={<></>}>
      <React.Suspense fallback={<Loader active />}>
        <StyledPage>
          <DynamicForm
            header={serverData?.header}
            steps={serverData?.steps}
            fields={serverData?.fields}
            meta={serverData?.meta}
            condition={serverData?.condition}
            themeColors={serverData?.theme}
            onNavClick={(pageId) => {
              console.log(pageId)
            }}
            onSubmit={handleSubmit}
          />
        </StyledPage>
      </React.Suspense>
       </ErrorBoundary>
  );
};

Forms.propTypes = {
  landingData: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired
};

const mapStateToProps = createStructuredSelector({
  landingData: makeSelectLandingPage()
});

const withConnect = connect(
  mapStateToProps
);

export default compose(
  withConnect,
  memo,
)(Forms);
